import { useGetUserProfile } from '@leagueplatform/web-common';

export function useGetDefaultTimezone() {
  const { data: userProfileData } = useGetUserProfile({ staleTime: Infinity });
  const { defaultTimezone } = userProfileData || {};
  return defaultTimezone;
}
